import { TextField } from "@mui/material"
import NumberFormat from "react-number-format"

export const InputsNumbers = (
    {
        label = '',
        name = '',
        value = 0,
        placeholder = '',
        onChange = () => null,
        disabled = false,
        separacion_miles = '.',
        separacion_decimales = ',',
        decimalScale = 2,
        simbolo = '$',
        type = ''
    }
) => {
    return (
        <>
            {type === 'text' ?
                <NumberFormat
                    value={value}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={simbolo !== '%' ? `${simbolo} ` : ''}
                    suffix={simbolo === '%' ? `%` : ''}
                    decimalScale={decimalScale}
                />
                :
                <NumberFormat
                    customInput={TextField}
                    label={label}
                    id={name}
                    size="small"
                    fullWidth
                    disabled={disabled}
                    name={name}
                    value={value}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={simbolo !== '%' ? `${simbolo} ` : ''}
                    suffix={simbolo === '%' ? `%` : ''}
                    onChange={onChange}
                    decimalScale={decimalScale}
                />
            }
        </>
    )
}

// <NumberFormat
//     customInput={TextField}
//     label="% dscto"
//     id="outlined-size-small"
//     size="small"
//     fullWidth
//     name="descuento_porcentaje"
//     value={form.descuento_porcentaje || 0}
//     thousandSeparator={separacion_miles}
//     decimalSeparator={separacion_decimales}
//     suffix={`%`}
//     onValueChange={(values, sourceInfo) => handleChangeDscto({ ...values, sourceInfo }, 'descuento_porcentaje')}
// />